"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWizardIndex = void 0;
var isTypeLinearS_1 = require("../types/typeGuards/isTypeLinearS");
var getWizardIndex = function (args) { return function () {
    if (!isTypeLinearS_1.isTypeLinearS(args.options)) {
        console.log('Wizard warning: ');
        return -1;
    }
    if (typeof args.step !== "string") {
        console.log('Wizard warning: ');
        return -1;
    }
    return args.options.indexOf(args.step);
}; };
exports.getWizardIndex = getWizardIndex;
//# sourceMappingURL=getWizardIndex.js.map